<template>
  <div class="set_sub_attr">
    <SwitchSubAttribute
      :key="editing_productType"
      :class="attribProps.name"
      v-bind="attribProps"
      :hasBoth="hasBothSubAttrib"
      @updateAttrib="setAttrib"
    />
  </div>
</template>

<script>
import SwitchSubAttribute from './SwitchAttribute.vue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  components: {
    SwitchSubAttribute
  },
  computed: {
    ...mapState('simulator', ['slat_category']),
    ...mapGetters(['modal_name']),
    ...mapGetters('simulator', ['editing_id', 'editing_item', 'editing_prefix', 'editing_productType', 'feature', 'is_slat_selected']),
    hasBothSubAttrib () {
      return (
        ['ZF', 'ZF-FE-PAIR', 'PL-PAIR', 'PL-DOUBLE', 'HS-PAIR', 'LD-PE-100'].includes(this.editing_productType)
        && ['SelectSlatCategory', 'BrowseSlatByCtg'].includes(this.modal_name)
      )
    },
    slatOCImgList () {
      switch (this.editing_prefix) {
        case 'DU':
          return [
            {
              alt: 'slat_close',
              src: require('../../assets/img/select/slat_close.svg')
            },
            {
              alt: 'slat_open',
              src: require('../../assets/img/select/slat_open.svg')
            }
          ]
        case 'T':
        case 'FT':
          return [
            {
              alt: 'slat_close',
              src: require('../../assets/img/select/slat_close2.svg')
            },
            {
              alt: 'slat_open',
              src: require('../../assets/img/select/slat_open2.svg')
            }
          ]
        case 'AR':
          return [
            {
              alt: 'slat_close',
              src: require('../../assets/img/select/slat_close6_AR.svg')
            },
            {
              alt: 'slat_open',
              src: require('../../assets/img/select/slat_open6_AR.svg')
            }
          ]
        default:
          return [
            {
              alt: 'slat_close',
              src: require('../../assets/img/select/slat_close3.svg')
            },
            {
              alt: 'slat_open',
              src: require('../../assets/img/select/slat_open3.svg')
            }
          ]
      }
    },
    attribSeacondaryTarget () {
      switch (this.feature?.type || '') {
        case 'frontBack':
          return {
            name: 'frontBack',
            values: [
              {
                label: '前生地',
                value: 'front'
              },
              {
                label: '奥生地',
                value: 'back'
              },
            ],
            imageList: this.editing_productType.startsWith('ZF')
              ? [
                  {
                    alt: 'zephry_front',
                    src: require('../../assets/img/select/zephry_back.svg')
                  },
                  {
                    alt: 'zephry_back',
                    // itentionally same as 'front'
                    // src: require('../../assets/img/select/zephry_front.svg')
                    src: require('../../assets/img/select/zephry_back.svg')
                  }
                ]
              : [
                  {
                    alt: 'perle_double_front',
                    src: require('../../assets/img/select/perle_double_back.svg')
                  },
                  {
                    alt: 'perle_double_back',
                    // itentionally same as 'front'
                    // src: require('../../assets/img/select/perle_double_front.svg')
                    src: require('../../assets/img/select/perle_double_back.svg')
                  }
              ]
          }
        case 'topBottom':
          return {
            name: 'topBottom',
            values: [
              {
                label: '上生地',
                value: 'top'
              },
              {
                label: '下生地',
                value: 'bottom'
              },
            ],
            imageList: [
              {
                alt: 'up',
                src: require(
                  this.editing_item.is_upper_lace
                    ? '../../assets/img/select/under.svg'
                    : '../../assets/img/select/up.svg'
                )
              },
              {
                // same as 'up' seems meaningless ... yes, it's intentional.
                alt: 'under',
                src: require(
                  this.editing_item.is_upper_lace
                    ? '../../assets/img/select/under.svg'
                    : '../../assets/img/select/up.svg'
                )
              },
            ]
          }
        default:
          return this.editing_productType === 'LD-PE-100'
            ? {
                name: 'drapeOrNot',
                values: [
                  {
                    label: 'ドレープ',
                    value: 'drape'
                  },
                  {
                    label: 'レース',
                    value: 'lace'
                  },
                ],
                imageList: [
                  {
                    alt: 'pair_ensemble_1',
                    src: require('../../assets/img/select/pair_ensemble_1.svg')
                  },
                  {
                    alt: 'pair_ensemble_2',
                    src: require('../../assets/img/select/pair_ensemble_2.svg')
                  }
                ]
              }
            : {}
      }
    },
    attrib3dModel () {
      return ['ZF', 'ZF-FE-PAIR', 'PL-PAIR', 'PL-DOUBLE', 'HS-PAIR'].includes(this.editing_productType)
        ? {
            title: '生地開閉',
            name: this.feature.type,
            values: [
              {
                label: this.editing_item.is_upper_lace ? '採光' : '全閉',
                value: 'close'
              },
              {
                label: '中間',
                value: 'half'
              },
              {
                label: this.editing_item.is_upper_lace ? '全閉' : '採光',
                value: 'open'
              },
            ],
            imageList:  [
              {
                alt: 'triple_close',
                src: require(
                    this.editing_item.is_upper_lace
                      ? '../../assets/img/select/triple_open_r.svg'
                      : '../../assets/img/select/triple_close.svg'
                  )
              },
              {
                alt: 'triple_half',
                src: require(
                  this.editing_item.is_upper_lace
                    ? '../../assets/img/select/triple_half_r.svg'
                    : '../../assets/img/select/triple_half.svg'
                )
              },
              {
                alt: 'triple_open',
                src: require(
                    this.editing_item.is_upper_lace
                      ? '../../assets/img/select/triple_close_r.svg'
                      : '../../assets/img/select/triple_open.svg'
                  )
              }
            ]
          }
        : {
            title: this.editing_prefix === 'DU' ? '生地開閉' : 'スラット開閉',
            name: 'normal',
            values: [
              {
                label: '全閉',
                value: 'close'
              },
              {
                label: '採光',
                value: 'open'
              },
            ],
            imageList: this.editing_productType === 'DU-LUMIE'
              ? [
                  {
                    alt: 'slat_close',
                    src: require('../../assets/img/select/slat_close4.svg')
                  },
                  {
                    alt: 'slat_open',
                    src: require('../../assets/img/select/slat_open4.svg')
                  }
              ]
              : this.editing_productType === 'LD-PE-100'
              ? [
                  {
                    alt: 'slat_close',
                    src: require('../../assets/img/select/slat_close5.svg')
                  },
                  {
                    alt: 'slat_open',
                    src: require('../../assets/img/select/slat_open5.svg')
                  }
              ]
              : this.slatOCImgList
          }
    },
    attribProps () {
      switch (this.feature?.type || '') {
        case 'weightBar':
          return {
            title: 'ウェイトバー',
            name: 'weightBar',
            values: [
              {
                label: '露出',
                value: 'exposed'
              },
              {
                label: '袋縫い',
                value: 'baged'
              },
            ],
            imageList: [
              {
                alt: 'slat_close',
                src: require('../../assets/img/select/weight_open.svg')
              },
              {
                alt: 'slat_open',
                src: require('../../assets/img/select/weight_close.svg')
              }
            ]
          }
        default:
          return this.hasBothSubAttrib
            ? this.attribSeacondaryTarget
            : this.attrib3dModel
      }
    }
  },
  methods: {
    ...mapMutations(['setModal']),
    ...mapMutations('simulator', ['setFeature', 'toggleTarget']),
    ...mapActions('simulator', ['updateItemInfo', 'setDisabledCtgId', 'setSlatCtgSelected']),
    setAttrib({name, value}) {
      if (this.hasBothSubAttrib) {
        this.toggleTarget();
        if (['frontBack', 'topBottom'].includes(name)) {
          if (!this.is_slat_selected) {
            this.setModal('SelectSlatCategory')
          }
          // 要 disabled_ctg_id の更新 (条件複雑)
        } else {
          if (value === 'drape') {
            this.setDisabledCtgId(['lace'])
            this.setModal('SelectSlatCategory')
          } else {
            this.setSlatCtgSelected({ id: 'lace' })
            this.setDisabledCtgId(
              this.slat_category.filter(({id}) => id !== 'lace').map(({id}) => id)
            )
            this.setModal('BrowseSlatByCtg')
          }
        }
        // this.updateItemInfo({feature: {type: name, value}});
      } else {
        this.updateItemInfo({feature: {type: name, value}});
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .set_sub_attr {
    height: 100%;
  }
</style>